import { Component, OnInit } from '@angular/core'
import { PayoutBatch, PayoutBatchStatusEnum, EnumNames } from '@parkupp/core'
import { PayoutBatchService } from '../../../services/payout-batch.service'
@Component({
    selector: 'app-admin-list-payout-batches',
    templateUrl: './admin-list-payout-batches.component.html',
    styleUrls: ['./admin-list-payout-batches.component.scss'],
})
export class AdminListPayoutBatchesComponent implements OnInit {
    EnumNames = EnumNames
    PayoutBatchStatusEnum = PayoutBatchStatusEnum
    PayoutBatchStatusValues = Object.values(PayoutBatchStatusEnum)
    payoutBatches: PayoutBatch[] = []
    filteredPayoutBatches: PayoutBatch[] = []
    // defaultStatus = PayoutBatchStatusEnum.DUE

    constructor(private payoutBatchService: PayoutBatchService) {}

    async ngOnInit() {
        this.payoutBatches = await this.payoutBatchService.getPayoutBatches()
        this.filteredPayoutBatches = this.payoutBatches
    }

    onStatusChange(event: Event) {
        const status = (event.target as HTMLSelectElement).value
        this.filterByStatus(status as PayoutBatchStatusEnum)
    }

    filterByStatus(status: PayoutBatchStatusEnum) {
        if (status) {
            this.filteredPayoutBatches = this.payoutBatches.filter((payoutBatch) => payoutBatch.status === status)
        } else {
            this.filteredPayoutBatches = this.payoutBatches
        }
    }
}
